<!--
 * @Author       : panyangyang
 * @Date         : 2026-08-26 16:19:54
 * @LastEditTime : 2026-09-11 09:09:50
 * @LastEditors  : panyangyang
 * @Description  :
 * @FilePath     : \ngs_platform_manage_admin\src\views\large-screen\left-panel\index.vue
-->
<template>
	<div class="left-panel">
		<!-- 收入分类 -->
		<div class="card left-bg1">
			<div class="card-header">收入分类</div>
			<div ref="inComePieChart" class="chart-container"></div>
		</div>

		<!-- 项目分类 -->
		<div class="card left-bg2">
			<div class="card-header">项目分类</div>
			<div class="card-content bid-num flex">
				<div class="block flex">
					<span class="num">{{ proInfo && proInfo.dianZiNum ? proInfo.dianZiNum : 0 }}</span>
					<span>电子标数量</span>
				</div>
				<div class="block flex">
					<span class="num paper-bid">{{ proInfo && proInfo.zhiZhiNum ? proInfo.zhiZhiNum : 0 }}</span>
					<span>纸质标数量</span>
				</div>
			</div>
		</div>

		<!-- 前十公司 -->
		<div class="card left-bg3">
			<div class="card-header">
				<div class="tab flex">
					<div
						v-for="(item, index) in bidType"
						:key="index + 'bidType'"
						:class="{ 'tab-item-line': true, active: item.name == activeBidType }"
						@click="changeBidType(item)"
					>
						<span class="line"></span>
						{{ item.label }}
					</div>
				</div>
			</div>
			<div class="card-content">
				<div class="tab flex">
					<div
						v-for="(item, index) in numType"
						:key="index + 'numType'"
						:class="{ 'tab-item': true, active: item.name == activeNumType }"
						@click="changeNumType(item)"
					>
						{{ item.label }}
					</div>
				</div>
				<div class="agency-list">
					<div v-for="(item, index) in topTenArr" :key="index + 'agency'" :class="{ 'agency-item': true, background: index / 2 == 0 }">
						<TextTooltip
							class="w100"
							:refName="index + '-' + item"
							:content="`${index + 1}、${item}`"
							:effect="'light'"
							:direaction="'bottom'"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import { debounce } from '@/utils/tools.js'
import * as Api from '@/api/modules/large-screen.js'
import TextTooltip from '@/views/operation-management/audit-affairs-new/components/TextTooltip'

export default {
	props: {
		// 左侧数据
		leftData: {
			type: Object,
			default: () => {
				return {}
			}
		},
		// 查询类型
		queryType: {
			type: String,
			default: '0'
		},
		// 查询日期
		queryDate: {
			type: String,
			default: ''
		}
	},
	components: {
		TextTooltip
	},
	data() {
		return {
			incomeArr: [], // 收入分类
			proInfo: {}, // 项目信息
			topTenArr: [], // 前十公司
			activeBidType: '0',
			bidType: [
				{ label: '前十代理机构', name: '0' },
				{ label: '前十招标人', name: '1' }
			],
			//
			activeNumType: '0',
			numType: [
				{ label: '按项目数', name: '0' },
				{ label: '按项目金额', name: '1' }
			],
			charts: {}
		}
	},
	created() {
		this.showData()
	},
	mounted() {
		this.handleResize = debounce(() => {
			this.resizeCharts()
		}, 100)
		// 监听窗口尺寸变化
		window.addEventListener('resize', this.handleResize)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize)
		Object.values(this.charts).forEach((chart) => {
			if (chart) chart.dispose()
		})
	},
	methods: {
		// 回显数据
		showData() {
			const { incomeArr = [], proInfo = {}, topTenArr = [] } = this.leftData
			this.incomeArr = incomeArr
			this.proInfo = proInfo
			this.topTenArr = topTenArr

			// 初始化图表
			setTimeout(() => {
				this.initCharts()
			}, 200)
		},

		// 切换代理招标人
		changeBidType(item) {
			this.activeBidType = item.name
			this.getTopCompany()
		},

		// 切换项目数/金额
		changeNumType(item) {
			this.activeNumType = item.name
			this.getTopCompany()
		},

		// 接口获取前十公司
		getTopCompany() {
			Api.getTopCompany({
				queryType: this.queryType,
				queryDate: this.queryDate,
				companyType: this.activeBidType, // 0：代理 ；1：招标人
				companyDis: this.activeNumType // 0：按项目；1：按预算
			}).then((res) => {
				this.topTenArr = res.data
			})
		},

		// 初始化图表
		initCharts() {
			this.initIncomePieChart()
		},

		// 收入分类饼图
		initIncomePieChart() {
			const chart = echarts.init(this.$refs.inComePieChart)
			const option = {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					right: 20,
					orient: 'vertical', // 垂直排列
					icon: 'circle', // 设置为圆形
					itemWidth: 8, // 设置圆点大小（直径）
					itemGap: 16, // 垂直间距
					textStyle: {
						color: '#C5DCFF',
						fontSize: 14
					}
				},
				series: [
					{
						name: '收入分类',
						type: 'pie',
						radius: ['40%', '70%'],
						center: ['30%', '50%'],
						minAngle: 5, // 最小角度，单位是度
						avoidLabelOverlap: true,
						itemStyle: {
							borderRadius: 5,
							borderColor: '#0a1a2f',
							borderWidth: 2
						},
						label: {
							show: false,
							formatter: '{b}\n{d}%',
							color: '#fff'
						},
						tooltip: { formatter: '{b} : {c} ({d}%)' },
						color: ['#41c4ee', '#7393e9', '#6fb1fb', '#38ceb4', '#c4df46', '#ffb068'],
						data: this.incomeArr
						// [
						// 	{ value: 400, name: '包年服务费' },
						// 	{ value: 300, name: '基础服务费' },
						// 	{ value: 200, name: '项目技术费' },
						// 	{ value: 200, name: '中标服务费' },
						// 	{ value: 200, name: '其他费用' }
						// ]
					}
				],
				color: ['#00d4ff', '#ffd700', '#ff6b6b']
			}
			chart.setOption(option)
			this.charts.projectPie = chart
		},

		// 窗口大小变化时重置图表
		resizeCharts() {
			setTimeout(() => {
				Object.values(this.charts).forEach((chart) => {
					if (chart) chart.resize()
				})
			}, 200)
		}
	},
	watch: {
		// 监听数据改变
		leftData: {
			deep: true,
			handler() {
				this.showData()
			}
		},
		// 监听查询条件改变
		queryType: {
			handler() {
				this.getTopCompany()
			}
		},
		queryDate: {
			handler() {
				this.getTopCompany()
			}
		}
	}
}
</script>

<style lang="less" scoped>
// 文字颜色渐变
.text-gradient {
	background-image: linear-gradient(to bottom, #76b6f5 0%, #edf4fc 100%);
	-webkit-background-clip: text;
	background-clip: text;
	color: transparent;
}
// 背景图设置
.image-set {
	background-size: 100% 100%;
	background-repeat: no-repeat;
}

.left-panel {
	// width: 470px;
	width: 25.3%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-height: 0;
}

.left-bg1 {
	height: 31%;
	background-image: url('~@/assets/images/screen/left-bg1.jpg');
	.image-set;
}

.left-bg2 {
	height: 18%;
	background-image: url('~@/assets/images/screen/left-bg2.jpg');
	.image-set;
	.bid-num {
		color: #c5dcff;
		font-size: 14px;
		padding: 0 118px 0 69px;
		justify-content: space-between;
		align-items: center;
		.block {
			flex-direction: column;
			align-items: center;
		}
		.num {
			line-height: 30px;
			font-size: 36px;
			color: #ffffff;
			margin-bottom: 10px;
		}
		.paper-bid {
			color: #f5b14c;
		}
	}
}

.left-bg3 {
	height: 51%;
	background-image: url('~@/assets/images/screen/left-bg3.jpg');
	.image-set;
}

// 代理机构列表样式
.agency-list {
	height: calc(100% - 39px);
	margin-top: 5px;
	display: flex;
	flex-direction: column;

	.agency-item {
		height: 29px;
		display: flex;
		align-items: center;
		font-size: 15px;
		color: #c5dcff;
		padding-left: 15px;
		transition: all 0.3s;

		&:nth-child(2n) {
			background: rgba(59, 161, 255, 0.14);
		}
	}
}
</style>
